import { doc, getDoc, collection, query, where, getDocs } from "firebase/firestore";
import { getFirebaseFirestore } from "@/config/firebase";
import type { Instructor } from "@vlab-corporation/vlab-pilates-service-interface/staff";

/**
 * 강사 문서를 조회한다.
 *
 * 경로: users/{ownerUid}/centers/{centerId}/instructors/{instructorId}
 */
export async function getInstructor(
  ownerUid: string,
  centerId: number,
  instructorId: string,
): Promise<Instructor | null> {
  const ref = doc(
    getFirebaseFirestore(),
    "users",
    ownerUid,
    "centers",
    String(centerId),
    "instructors",
    instructorId,
  );
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() } as Instructor;
}

/**
 * 수업 담당 강사를 staffId로 조회한다 (대리작성 시 수업 담당 강사의 instructorId 확보용).
 *
 * - staffId가 숫자(매핑된 강사)면 studiomateMapping.staffId가 일치하는 강사를 반환한다.
 * - staffId가 문자열(미매핑 강사)이면 그 값이 곧 userUid(=instructor 문서 id)이므로
 *   해당 instructor 문서를 직접 조회한다.
 */
export async function getInstructorByStaffId(
  ownerUid: string,
  centerId: number,
  staffId: number | string,
): Promise<(Instructor & { studiomateMapping?: { staffId: number; staffName: string } }) | null> {
  // 미매핑 강사: staffId = userUid(문자열) = instructor 문서 id
  if (typeof staffId === "string") {
    return getInstructor(ownerUid, centerId, staffId) as Promise<
      (Instructor & { studiomateMapping?: { staffId: number; staffName: string } }) | null
    >;
  }

  const col = collection(
    getFirebaseFirestore(),
    "users",
    ownerUid,
    "centers",
    String(centerId),
    "instructors",
  );
  const q = query(col, where("studiomateMapping.staffId", "==", staffId));
  const snap = await getDocs(q);
  if (snap.empty) return null;
  const d = snap.docs[0];
  return { id: d.id, ...d.data() } as Instructor & {
    studiomateMapping?: { staffId: number; staffName: string };
  };
}
